import React,{useState,useEffect} from 'react'
import axios from 'axios'
import {AuthProvider,useAuth} from '../index'
import { Link as RouterLink, useLoaderData,createBrowserRouter, createRoutesFromElements, Navigate, Await, BrowserRouter, Route, Routes, NavLink, useNavigate, useLocation, useOutlet, useParams} from 'react-router-dom'
import { MdEdit } from 'react-icons/md'
import { IoMdClose,IoIosLogOut } from 'react-icons/io'

const APIURL = process.env.NODE_ENV === 'production' ? `${process.env.REACT_APP_DB_ENV}` : `${process.env.REACT_APP_DB_ENV_TEST}`

export default function LoginPage({selectedPage5}){
    // const { login, auth2FA1, autoLogin, logout } = useAuth()
    // const [loginCheck, setLoginCheck] = useState(false)
    const [msg, setMsg] = useState('')
    // const [data, setData] = useState('')
    const [loginBtn, setLoginBtn] = useState(false)
    // const [resendBtn, setResendBtn] = useState(false)
    // useEffect(() => {
    //       if(!loginCheck){
    //         const x = window.localStorage.getItem('token')
    //        if (x) {
    //         tokenCheck(x)
    //         const code = '1'
    //        auth2FA1({ code })
    //        }
    //       }
    //  })
    //  const tokenCheck = async(x) => {
    //       try {
    //            const { data: res } = await axios.post(`${APIURL}/auto-login`, {'token':x})
    //            if (res.msg==='You are auto logined.'){
    //                 if(res.user.firstname!='' && res.user.lastname!=''){
    //                      await autoLogin({'username':res.user.username,'url':`https://ui-avatars.com/api/?name=${res.user.firstname[0]}+${res.user.lastname[0]}&background=000&color=fff`,'unlocked_code':res.user.unlocked_code})
    //                 }else{
    //                      await autoLogin({'username':res.user.username,'url':`https://ui-avatars.com/api/?name=${res.user.email[0]}&background=000&color=fff`,'unlocked_code':res.user.unlocked_code})
    //                 }
    //              }else{
    //                 logout()
    //              }
    //       } catch (e) {console.log(e)}
    //       setLoginCheck(true)
    //  }
    const onChangeInput = ({ currentTarget: input }) => { setData({ ...data, [input.name]: input.value }) }

    const onClick2Login = async() =>{
    //     setLoginBtn(true)
    //     console.log(data)
    //     const { data: res } = await axios.post(`${APIURL}/login`, data)
    //     //redirected to /react
    //     // console.log('login button clicked',res)
    //     // loginData1({
    //     //   id:res.user.id,
    //     //   username:res.user.username,
    //     //   email:data.email,
    //     //   pwd:data.pwd,
    //     //   role:res.user.role,
    //     //   msg:res.msg,
    //     //   iatstring:new Date(Number(res.tokenInfo.iat)*1000).toString(),
    //     //   expstring:new Date(Number(res.tokenInfo.exp)*1000).toString(),
    //     //   iat:Number(res.tokenInfo.iat),
    //     //   exp:Number(res.tokenInfo.exp),
    //     //   justLogined:'true',
    //     //   users:res.users
    //     // })
    //     // setJustLogined(true)
    //     // {msg: "You are logined.", tokenInfo: {exp: "1745678963", iat: "1745074163", token: "e"},
    //     // user: confirmed: "ok"
    //     // email: ""
    //     // pwd: "$"
    //     // role: "free"
    //     if (res.msg==='You are logined.'){
    //         setMsg(res.msg)
    //         localStorage.setItem('token', res.tokenInfo.token)
    //         // const email = res.user.email
    //         const code = '1'
    //         // await login({ email })
    //         // await login(res.user)
    //         if(res.user.firstname!='' && res.user.lastname!=''){
    //             await login({'username':`${res.user.username}`,'url':`https://ui-avatars.com/api/?name=${res.user.firstname[0]}+${res.user.lastname[0]}&background=000&color=fff`,'unlocked_code':res.user.unlocked_code})
    //         }else{
    //             await login({'username':res.user.username,'url':`https://ui-avatars.com/api/?name=${res.user.email[0]}&background=000&color=fff`,'unlocked_code':res.user.unlocked_code})
    //         }
    //         await auth2FA1({ code })
    //     }
    //     setMsg(res.msg)
    //     setLoginBtn(false)
    // }
    // const onClick2ResendConfirmation = async() =>{
    //     setResendBtn(true)
    //     const { data: res } = await axios.post(`${APIURL}/resend-confirmation`, data)
    //     console.log(res)
    //     setResendBtn(false)
    //     // loginData1({
    //     //   id:res.user.id,
    //     //   username:res.user.username,
    //     //   email:data.email,
    //     //   pwd:data.pwd,
    //     //   role:res.user.role,
    //     //   msg:res.msg,
    //     //   iatstring:new Date(Number(res.tokenInfo.iat)*1000).toString(),
    //     //   expstring:new Date(Number(res.tokenInfo.exp)*1000).toString(),
    //     //   iat:Number(res.tokenInfo.iat),
    //     //   exp:Number(res.tokenInfo.exp),
    //     //   justLogined:'true',
    //     //   users:res.users
    //     // })
    //     // setJustLogined(true)
    //     // {msg: "You are logined.", tokenInfo: {exp: "1745678963", iat: "1745074163", token: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6I…jMifQ.4V2HjqSX0CLwn2yxZZNQErcuqwkD89o7odUtNsKTF8w"},
    //     // user: confirmed: "ok"
    //     // email: "kaede.nakashima@protonmail.com"
    //     // pwd: "$2b$14$9dRbTIv.ieGzz8uUMEycoOouFQR76BNQrm2I0g/Quk1H/07jgt0hK"
    //     // role: "free"
    //     // if (res.msg==='You are logined.'){
    //     //     setMsg(res.msg)
    //     //     localStorage.setItem('token', res.tokenInfo.token)
    //     //     // const email = res.user.email
    //     //     const code = '1'
    //     //     // await login({ email })
    //     //     // await login(res.user)
    //     //     await login({'username':res.user.username,'url':`https://ui-avatars.com/api/?name=${res.user.firstname[0]}+${res.user.lastname[0]}&background=000&color=fff`})
    //     //     await auth2FA1({ code })
    //     // }
    //     setMsg(res.msg)
    }
    return(
        <>
       <div className='mt-4 max-w-[650px] m-auto bitter text-gray-800'>
       <h2 className='mb-4 text-lg'>Login</h2>
        <div className='md:m-auto flex w-fit'>
        <div className='flex-col w-[80px] text-right mr-1'><div className='text-[11px] mt-[6px] mb-[14px]'>Email</div><div className='text-[11px] mt-[6px] mb-[14px]'>Password</div></div>
        <div className='flex-col text-left w-fit md:w-[362px]'>
        <input name='email' className='border border-gray-800 primary-input structure__login__input w-full md:w-96' onChange={onChangeInput}/>
        <input name='pwd' className='border border-gray-800 mt-1 primary-input w-full md:w-96' onChange={onChangeInput}/>
        <div className='mt-1 flex w-full text-center'><button className='hover:bg-[#365c88] disabled:bg-[#dcdcdc] disabled:border disabled:border-gray-200 bg-[#414c75] h-[28px] text-[13px] pl-[12px] pr-[12px] text-white m-auto font-lighter' onClick={onClick2Login}  disabled={loginBtn}>Login</button></div>
        {msg=='You need to confirm your account from mailbox first.'?<div className='m-auto mt-8'>
        <input name='registered_email' className='primary-input structure__login__input w-full md:w-[340px]' placeholder='Your registered email' onChange={onChangeInput}/><button className='primary-btn  mt-1 ml-1' onClick={onClick2ResendConfirmation} disabled={resendBtn}>Resend</button><br/>
        </div>:''}
        <div className='text-center mb-1'>{msg}</div>
        <div className='text-center'>
            <div className='leading-[9px]'><RouterLink className='text-center underline text-[9px]' to='/reset-pwd'>Forgot your password? Reset your password.</RouterLink></div>
            <div className='leading-[11px]'><RouterLink className='text-center underline text-[9px]' to='/signup'>Don't have an account? Create your account first.</RouterLink></div>
        </div>
        </div>
        </div>
        <br/><br/> 
        </div>
        </>
    )
}